/**
 * TANIMLI SEÇİM — "listeden seç · yoksa tanımla".
 *
 * Elle yazılan serbest metin yerine YÖNETİLEN bir listeden seçim yaptırır.
 * Listenin sonunda "+ Yeni tanımla…" satırı vardır: tanımlama yetkisi olan
 * kullanıcıda ekrandan ayrılmadan tanım penceresini açtırır (`yeniTanimla`);
 * yetkisi olmayanda aynı yerde tıklanamayan bir bilgi satırı durur.
 *
 * Bileşen GENELDİR: hangi listenin (vade, sipariş kaynağı, iptal nedeni…)
 * bağlandığını bilmez. Tanım penceresini çağıran ekran açar; kaydedince yeni
 * kimliği `degis` ile seçili yapar.
 */
export type TanimSecenek = { id: string; ad: string; alt?: string | null };

const YENI = '__yeni__';

export default function TanimliSecim({
  id, secenekler, deger, degis, bosEtiket = '— seçilmedi —', disabled, yukleniyor,
  tanimlayabilir, yeniTanimla, yeniEtiket = '+ Yeni tanımla…',
  yetkisizNot = 'Listede yoksa yöneticiden tanımlamasını isteyin', ekSecenek, ...kalan
}: {
  id?: string; secenekler: TanimSecenek[]; deger: string; degis: (id: string) => void;
  /** Boş seçimin adı; null verilirse boş seçim sunulmaz. */
  bosEtiket?: string | null;
  disabled?: boolean; yukleniyor?: boolean;
  /** Kullanıcı bu listeye tanım ekleyebilir mi (yetki bayrağı). */
  tanimlayabilir: boolean;
  /** "+ Yeni tanımla…" seçilince çağrılır; seçim değişmez. */
  yeniTanimla?: () => void;
  yeniEtiket?: string; yetkisizNot?: string;
  /** Seçili değer artık listede yoksa (tanım silinmiş) kayıttaki adıyla gösterilir. */
  ekSecenek?: TanimSecenek | null;
  'data-tur'?: string;
}) {
  const listede = secenekler.some((s) => s.id === deger);
  return (
    <select id={id} className="ccd-select" value={deger} disabled={disabled} data-tur={kalan['data-tur']}
            onChange={(e) => { if (e.target.value === YENI) yeniTanimla?.(); else degis(e.target.value); }}>
      {bosEtiket != null && <option value="">{yukleniyor ? 'Yükleniyor…' : bosEtiket}</option>}
      {deger && !listede && ekSecenek && <option value={ekSecenek.id}>{ekSecenek.ad} (listeden kaldırılmış)</option>}
      {secenekler.map((s) => (
        <option key={s.id} value={s.id}>{s.ad}{s.alt ? ` — ${s.alt}` : ''}</option>
      ))}
      {tanimlayabilir && yeniTanimla
        ? <option value={YENI}>{yeniEtiket}</option>
        : <option value="__bilgi__" disabled>{yetkisizNot}</option>}
    </select>
  );
}
